// src/data/labMockData.ts

import type {
  CompletedTest,
  OngoingTest,
  Patient,
  TestRequest,
} from "../types/lab-context.types";

// Laboratory Mock Data
 // TODO:
 // Remove this file once the laboratory backend is connected.
 
export const LAB_TEST_REQUESTS: TestRequest[] = [];

export const LAB_ONGOING_TESTS: OngoingTest[] = [];

export const LAB_COMPLETED_TESTS: CompletedTest[] =
  [];

export const LAB_PATIENTS: Patient[] =
  [];